import { ListItemResponse, ListResponse } from "@/web-client/api";
import { FC, useCallback, useState } from "react";
import EditListTemplate from "@/features/list/components/EditListTemplate";
import EditSelectCoverForListTemplate from "@/features/list/components/EditSelectCoverForListTemplate";
import Modal from "@/components/Modal";

interface Props {
  isOpen: boolean;
  closeHandler: () => void;
  list: ListResponse;
}

export enum ModalEditListPhase {
  Edit = 1,
  SelectCover = 2,
}

const scrollableTargetId = "ModalEditList";

const ModalEditList: FC<Props> = ({
  isOpen,
  closeHandler,
  list,
}): JSX.Element => {
  const [phase, setPhase] = useState(ModalEditListPhase.Edit);
  const [selectedListItem, setSelectedListItem] =
    useState<ListItemResponse>(null);

  const selectedHandler = useCallback(
    (listItem: ListItemResponse) => {
      setSelectedListItem(listItem);
    },
    [setSelectedListItem],
  );

  return (
    <Modal
      contentStyle={{ maxWidth: 560 }}
      isOpen={isOpen}
      closeHandler={closeHandler}
      scrollableTargetId={scrollableTargetId}
    >
      <div className="px-16 pb-12">
        {phase === ModalEditListPhase.Edit && (
          <EditListTemplate
            move={setPhase}
            list={list}
            listItemForCover={selectedListItem}
            onComplete={closeHandler}
          />
        )}

        {phase === ModalEditListPhase.SelectCover && (
          <EditSelectCoverForListTemplate
            scrollableTargetId={scrollableTargetId}
            list={list}
            move={setPhase}
            onSelected={selectedHandler}
          />
        )}
      </div>
    </Modal>
  );
};

export default ModalEditList;
